import round from 'lodash/round'

export const formatPrecision = (value, precision) => round(value, precision).toFixed(precision).toString()

export const getSelectOptions = (object) => Object.entries(object).map(([value, label]) => ({ label, value }))

export default {}
